import accountHelper from "@/utils/helpers/account";

const order = orderID =>
  `<a href="https://admin.donamaid.com/pedido/${orderID}" target="_blank" rel="noopener noreferrer">Link da limpeza</a>`;

const professional = professional =>
  `<a href="https://admin.donamaid.com/profissionais/${
    professional.id
  }" target="_blank" rel="noopener noreferrer">${accountHelper.fullName(
    professional.account
  )}</a>`;

const customer = customer =>
  `<a href="https://admin.donamaid.com/clientes/${customerEndpoint(
    customer
  )}" target="_blank" rel="noopener noreferrer">${accountHelper.fullName(
    customer.account
  )}</a>`;

const customerEndpoint = customer =>
  (customer.type === "physicals" ? "b2c" : "b2b") + `/${customer.account.id}`;

export default {
  customer,
  order,
  professional
};



// WEBPACK FOOTER //
// ./src/api/helpers/freshdesk/buildLink.js